import React, { useEffect, useState } from "react";
import "./App.scss";

/**Services**/
import { setUserDataForAPI } from "./services/AxiosInterceptor";
import { getDetailsForUser } from "./services/UserService";
import BackendService from "./services/BackendService";

/**Components**/
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import EmailOTP from "./pages/auth/EmailOTP";
import MobileOTP from "./pages/auth/MobileOTP";
import ResetPassword from "./pages/auth/ResetPassword";
import MainLayout from "./layouts/MainLayout";

/**Other Config/Utils/Constants**/
import {
  AUTH_ROUTES,
  logoutUserFromCurrentDevice,
} from "./utils/constants/userConstants";

/**Third-Part Components**/
import { Amplify, Auth } from "aws-amplify";
import { AWSIoTProvider } from "@aws-amplify/pubsub/lib/Providers";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

import "./assets/styles/mixins/_breakpoint.scss";

Amplify.addPluggable(
  new AWSIoTProvider({
    aws_pubsub_region: "us-east-2",
    aws_pubsub_endpoint: `wss://a1v7l33zuyun81-ats.iot.us-east-2.amazonaws.com/mqtt`,
  })
);

export function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [checkAuth, setCheckAuth] = useState(false);
  const [keepMeLoginDays, setkeepMeLoginDays] = useState(5);

  const checkUser = async () => {
    try {
      await BackendService.getConfig("");
      const data = await Auth.currentAuthenticatedUser();
      const username = data?.signInUserSession?.accessToken?.payload?.username;
      const devicekey =
        data?.signInUserSession?.accessToken?.payload?.device_key;
      const keepmelogin = localStorage.getItem("keepmelogin");
      const skeepmelogin = sessionStorage.getItem("keepmelogin");
      if (skeepmelogin === null) {
        if (keepmelogin === null || keepmelogin === "false") {
          await logoutUserFromCurrentDevice(username, devicekey);
          setCheckAuth(true);
          // await Auth.signOut();
          // navigate("/signin");
        } else {
          /**When user selects keep me login & visit this website after closing tab/browser
           * then on next visit to website this block will execute
           **/
          const queryParam = {
            cognitoId: username,
          };
          setUserDataForAPI(data);
          getDetailsForUser(queryParam)
            .then(async (response) => {
              const userDetailsResponse = response?.data?.UserDetails;
              let last_login_date;
              let commonInfo = userDetailsResponse?.ClientData?.commonInfo;
              const commonInfoKey = `${devicekey}&${username}`;
              if (commonInfo && commonInfo[commonInfoKey]) {
                last_login_date = commonInfo[commonInfoKey]?.lastLoginTime;
              }

              // if (clientData?.loginInfo) {
              //   clientData.loginInfo.forEach((x, i) => {
              //     if (x.DeviceID === devicekey) {
              //       last_login_date = x.lastLoginTime;
              //     }
              //   });
              // }

              let keep_me_login_days =
                response?.data?.TenantDetails?.KeepMeLoggedInDays;

              if (last_login_date && keep_me_login_days) {
                let date = new Date(last_login_date);
                setkeepMeLoginDays(Number(keep_me_login_days));
                let current_time = new Date();

                const diffTime = Math.abs(current_time - date);
                const diffDays = diffTime / (1000 * 60 * 60 * 24);

                if (Number(diffDays) > Number(keep_me_login_days)) {
                  localStorage.setItem("keepmelogin", false);
                  await logoutUserFromCurrentDevice(username, devicekey);
                  setCheckAuth(true);
                  // await Auth.signOut();
                  // navigate("/signin");
                } else {
                  sessionStorage.setItem("keepmelogin", "signin");
                  setCheckAuth(true);
                  const pathnameArray = location.pathname.split("/");
                  navigate(
                    AUTH_ROUTES.includes(pathnameArray[1])
                      ? "/"
                      : location.pathname
                  );
                }
              } else {
                sessionStorage.setItem("keepmelogin", "signin");
                setCheckAuth(true);
                const pathnameArray = location.pathname.split("/");
                navigate(
                  AUTH_ROUTES.includes(pathnameArray[1])
                    ? "/"
                    : location.pathname
                );
              }
            })
            .catch(async function (error) {
              // console.log(error);
              localStorage.setItem("keepmelogin", false);
              await logoutUserFromCurrentDevice(username, devicekey);
              // await Auth.signOut();
              setCheckAuth(true);
              // navigate("/signin");
            });
        }
      } else {
        sessionStorage.setItem("keepmelogin", "signin");
        setCheckAuth(true);
        navigate(location.pathname);
      }
    } catch (err) {
      setCheckAuth(true);
      navigate(location.pathname === "/" ? "/signin" : location.pathname);
    }
  };

  useEffect(() => {
    checkUser();
  }, []);

  if (checkAuth) {
    return (
      <Routes>
        <Route exact path="/signin" element={<SignIn />}></Route>
        {/* <Route exact path="/signup" element={<SignUp />}></Route>*/}
        <Route exact path="/signup/:id" element={<SignUp />}></Route>
        <Route exact path="/confirmemail" element={<EmailOTP />}></Route>
        <Route exact path="/confirmmobile" element={<MobileOTP />}></Route>
        <Route exact path="/resetpassword" element={<ResetPassword />}></Route>
        <Route path="/*" element={<MainLayout />}></Route>
      </Routes>
    );
  } else {
    return null;
  }
}

export default App;
